var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"align-center layout px-4 pt-4 app--page-header",attrs:{"row":""}},[_c('div',{staticClass:"page-header-left"},[_c('h3',{staticClass:"pl-3 pr-3 primary--text"},[_vm._v(_vm._s(_vm.$route.meta.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }